export class FinishCallInput {
  leadId: string;
  reportTime: string;
  onTrackStatus: string;
  resultCall: string;
  comments: string;
}
